"use client"

"use client"

import { ArrowLeft, ArrowPath, TruckFast } from "@medusajs/icons"

import Accordion from "./accordion"
import { HttpTypes } from "@medusajs/types"
import { useFrontendPreferences } from "@lib/frontend-preferences"

type ProductTabsProps = {
  product: HttpTypes.StoreProduct
}

const ProductTabs = ({ product }: ProductTabsProps) => {
  const { locale, t } = useFrontendPreferences()
  const tabs = [
    {
      label: t.product.productInformation,
      component: <ProductInfoTab product={product} />,
    },
    {
      label: t.product.shippingAndReturns,
      component: <ShippingInfoTab />,
    },
  ]

  return (
    <div className="w-full" dir={locale === "fa" ? "rtl" : "ltr"}>
      <Accordion type="multiple">
        {tabs.map((tab, i) => (
          <Accordion.Item
            key={i}
            title={tab.label}
            headingSize="medium"
            value={tab.label}
          >
            {tab.component}
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  )
}

const ProductInfoTab = ({ product }: ProductTabsProps) => {
  const { t } = useFrontendPreferences()
  return (
    <div className="text-small-regular py-8">
      <div className="grid grid-cols-2 gap-x-8">
        <div className="flex flex-col gap-y-4">
          <div>
            <span className="font-semibold">{t.product.material}</span>
            <p>{product.material ? product.material : "-"}</p>
          </div>
          <div>
            <span className="font-semibold">{t.product.countryOfOrigin}</span>
            <p>{product.origin_country ? product.origin_country : "-"}</p>
          </div>
          <div>
            <span className="font-semibold">{t.product.type}</span>
            <p>{product.type ? product.type.value : "-"}</p>
          </div>
        </div>
        <div className="flex flex-col gap-y-4">
          <div>
            <span className="font-semibold">{t.product.weight}</span>
            <p>{product.weight ? `${product.weight} ${t.product.grams}` : "-"}</p>
          </div>
          <div>
            <span className="font-semibold">{t.product.dimensions}</span>
            <p>
              {product.length && product.width && product.height
                ? `${product.length}L x ${product.width}W x ${product.height}H`
                : "-"}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

const ShippingInfoTab = () => {
  const { t } = useFrontendPreferences()
  return (
    <div className="text-small-regular py-8">
      <div className="grid grid-cols-1 gap-y-8">
        <div className="flex items-start gap-x-2">
          <TruckFast />
          <div>
            <span className="font-semibold">{t.product.fastDelivery}</span>
            <p className="max-w-sm">
              {t.product.fastDeliveryBody}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-x-2">
          <ArrowPath />
          <div>
            <span className="font-semibold">{t.product.simpleExchanges}</span>
            <p className="max-w-sm">
              {t.product.simpleExchangesBody}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-x-2">
          <ArrowLeft className="sahil-product-tab__return-icon" />
          <div>
            <span className="font-semibold">{t.product.easyReturns}</span>
            <p className="max-w-sm">
              {t.product.easyReturnsBody}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductTabs
